import TEmployee from "@/types/employee/TEmployee";
import DeleteButton from "@components/buttons/DeleteButton";
import EditButton from "@components/buttons/EditButton";
import { GrNotes as NoteIcon } from "react-icons/gr";
import { RxEyeOpen as EyeIcon } from "react-icons/rx";

export const teamColumns = (
  editHandler: (val: any) => void,
  deleteHandler: (val: any) => void
) => [
  {
    name: "Team Name",
    selector: (row: any) => row.team_name,
    sortable: true,
    wrap: true,
  },
  {
    name: "HOD Name",
    selector: (row: any) => row.employee_name,
    sortable: true,
    wrap: true,
  },
  {
    name: "Department",
    selector: (row: any) => row.dept_name,
    sortable: true,
  },

  {
    name: "Action",
    right: true,
    selector: (row: any) => (
      <div className="flex gap-3 items-center">
        <EditButton
          id={row.team_id as any}
          actionHandler={() => editHandler(row)}
        />
        <DeleteButton
          id={row.team_id as any}
          actionHandler={() => deleteHandler(row)}
        />
      </div>
    ),
  },
];
